<template>
  <div class="clientContent">
    <div class="clientForm">
      <el-form label-width="100px" :rules="rules" ref="clientFormRules" :model="clientInfo">
        <div class="flexStyle mainContent">
          <div class="imgStyle">
            <upload-image
              :imageUrl.sync="clientInfo.headPortrait"
              :imageUrls.sync="clientInfo.headPortraits"
            />
            <el-button v-if="clientInfo.headPortraits" @click="deleteImg" style="margin-top: 10px"
              >删除图片</el-button
            >
          </div>
          <div style="flex: 1">
            <div class="flexStyle">
              <div>
                <el-form-item label="姓名：" prop="name">
                  <el-input v-model="clientInfo.name"></el-input>
                </el-form-item>
                <el-form-item label="出生年份：" prop="">
                  <el-select
                    v-model="clientInfo.birthYear"
                    @change="birthYearChange"
                    style="width: 120px"
                  >
                    <el-option
                      v-for="item in yearList"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="婚姻状态：" prop="weddingOrNot">
                  <el-radio-group v-model="clientInfo.weddingOrNot">
                    <el-radio :label="0">已婚</el-radio>
                    <el-radio :label="1">未婚</el-radio>
                    <el-radio :label="2">未知</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="联系电话：" prop="phone">
                  <div class="flexStyle">
                    <el-input v-model="clientInfo.phone"></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="所属行业：" prop="listCurrentIndustry">
                  <dic-cascader typeCode="004" :selectValue.sync="clientInfo.listCurrentIndustry" />
                </el-form-item>
              </div>
              <div style="margin-left: 100px">
                <el-form-item label="当前状态：">
                  <el-select v-model="clientInfo.state" style="width: 150px">
                    <el-option label="在职" value="在职"></el-option>
                    <el-option label="待就业" value="待就业"></el-option>
                    <el-option label="已推荐" value="已推荐"></el-option>
                  </el-select>
                </el-form-item>
                <div class="flexStyle">
                  <el-form-item label="性别：" prop="sex">
                    <el-select v-model="clientInfo.sex" style="width: 120px">
                      <el-option label="男" value="男"></el-option>
                      <el-option label="女" value="女"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="年龄：" prop="age" label-width="80px">
                    <el-input
                      v-model="clientInfo.age"
                      @input="ageInput"
                      style="width: 100px"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="所在地：">
                  <div class="flexStyle">
                    <CascaderArea
                      :country="clientInfo.personCountry"
                      :province="clientInfo.personProvince"
                      :city="clientInfo.personCity"
                      @searchArae="searchArae"
                    />
                  </div>
                </el-form-item>
                <div class="flexStyle">
                  <el-form-item label="邮箱：">
                    <div class="flexStyle">
                      <el-input v-model="clientInfo.mail" style="width: 200px"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="微信：" label-width="60px">
                    <div class="flexStyle">
                      <el-input v-model="clientInfo.weChat" style="width: 200px"></el-input>
                    </div>
                  </el-form-item>
                </div>
                <el-form-item label="入职时间：" prop="entryTime" class="radioButtonStyle">
                  <el-radio-group v-model="clientInfo.timeChoose" style="margin-left: 10px">
                    <el-radio-button :label="0">一个月离职通知</el-radio-button>
                    <el-radio-button :label="1">随时</el-radio-button>
                  </el-radio-group>
                  <el-input
                    v-model="clientInfo.entryTime"
                    style="width: 150px"
                    placeholder="请填写日期"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="教育背景：" prop="listEducationBackground">
              <el-checkbox-group v-model="clientInfo.listEducationBackground">
                <el-checkbox label="统招" value="统招"></el-checkbox>
                <el-checkbox label="非统招" value="非统招"></el-checkbox>
                <el-checkbox label="985" value="985"></el-checkbox>
                <el-checkbox label="211" value="211"></el-checkbox>
                <el-checkbox label="留学背景" value="留学背景"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <div class="flexStyle">
              <el-form-item label="语言能力：" prop="workingYears">
                <div
                  class="flexStyle"
                  v-for="(item, index) in listLanguageAbility"
                  :key="index"
                  style="margin-bottom: 5px"
                >
                  <div>
                    <el-select
                      v-model="item.LanguageAbility"
                      style="width: 120px"
                      allow-create
                      filterable
                    >
                      <el-option label="中文" value="中文"></el-option>
                      <el-option label="英文" value="英文"></el-option>
                      <el-option label="日语" value="日语"></el-option>
                      <el-option label="法语" value="法语"></el-option>
                      <el-option label="俄语" value="俄语"></el-option>
                      <el-option label="德语" value="德语"></el-option>
                    </el-select>
                    <el-select v-model="item.LanguageLevel" style="width: 120px; margin-left: 15px">
                      <el-option label="母语" value="母语"></el-option>
                      <el-option label="流利" value="流利"></el-option>
                      <el-option label="优秀" value="优秀"></el-option>
                      <el-option label="良好" value="良好"></el-option>
                      <el-option label="一般" value="一般"></el-option>
                    </el-select>
                  </div>
                  <div
                    class="personEducationalDivRadio"
                    @click="addpersonEducationalDivRadio"
                    v-if="listLanguageAbility && listLanguageAbility.length == index + 1"
                  >
                    <i class="el-icon-circle-plus-outline"></i>
                    <span>添加</span>
                  </div>
                  <div
                    class="personEducationalDivRadio"
                    @click="removepersonEducationalDivRadio(index)"
                    v-if="listLanguageAbility && listLanguageAbility.length > 1"
                  >
                    <i class="el-icon-remove-outline"></i>
                    <span>删除</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="求职渠道：" prop="jobChannels">
                <el-input v-model="clientInfo.jobChannels" style="width: 400px"></el-input>
              </el-form-item>
            </div>

            <el-form-item label="工作经验：" prop="workingYears">
              <el-radio-group v-model="clientInfo.workingYears">
                <el-radio
                  v-for="(item, index) in options"
                  :label="item"
                  :value="item"
                  :key="index"
                ></el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="flexStyle">
              <el-form-item label="职位类型：">
                <drop-down-box
                  :selectValue.sync="clientInfo.personType"
                  typeCode="008"
                  class="drop-down-box"
                />
              </el-form-item>
              <div style="flex: 1">
                <el-form-item label="个人荣誉标签：" label-width="140px">
                  <el-tag
                    :key="index + 10"
                    v-for="(tag, index) in clientInfo.listPersonalGlory"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                  >
                    {{ tag }}
                  </el-tag>
                  <el-input
                    class="input-new-tag small_input"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  >
                  </el-input>
                  <el-button v-else class="button-new-tag" size="small" @click="showInput"
                    >添加标签</el-button
                  >
                </el-form-item>
              </div>
            </div>
            <el-form-item label="人才评估 ：">
              <el-input
                type="textarea"
                v-model="clientInfo.other"
                :autosize="{ minRows: 4, maxRows: 10 }"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px" v-show="false">
          <div class="flexStyleBottom">
            <title-bar title="工作经历"></title-bar>
            <div class="personEducationalDiv" @click="addpersonDetailsWorkExperiences">
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div>
          </div>
          <div
            v-for="(item, index) in clientInfo.personDetailsWorkExperiences"
            :key="index + 20"
            class="personEducational"
          >
            <el-date-picker
              v-model="item.inductionTime"
              type="month"
              placeholder="选择日期"
              style="width: 150px"
              value-format="yyyy-MM"
            >
            </el-date-picker>
            ~
            <el-date-picker
              v-model="item.quitTime"
              type="month"
              placeholder="选择日期"
              value-format="yyyy-MM"
              style="width: 150px; margin-right: 20px"
            >
            </el-date-picker>
            <el-input
              v-model="item.companyName"
              style="width: 250px; margin-right: 20px"
              placeholder="请输入公司名称"
            ></el-input>
            <!-- <drop-down-box :selectValue.sync="item.education" typeCode="007" class="drop-down-box" /> -->
            <el-input
              v-model="item.position"
              style="width: 250px; margin-right: 20px"
              placeholder="请输入职位"
            ></el-input>
            <div style="margin-top: 10px">
              <el-input
                v-model="item.salaryExpectation"
                style="width: 150px"
                placeholder="薪资范围"
              ></el-input>
              ~
              <el-input
                v-model="item.salaryExpectationEnd"
                style="width: 150px"
                placeholder="薪资范围"
              ></el-input>
              <el-input
                v-model="item.department"
                style="width: 250px; margin-left: 20px"
                placeholder="请输入所在部门"
              ></el-input>
              <el-input
                v-model="item.reportingObject"
                style="width: 250px; margin-left: 20px"
                placeholder="请输入汇报对象"
              ></el-input>
              <div class="personEducationalDiv" @click="deletepersonDetailsWorkExperiences(index)">
                <i class="el-icon-remove-outline"></i>
                <span>删除</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="职位期望"></title-bar>
          <div class="expected">
            <i class="iconfont icon-jr-icon-address"></i>
            <el-form-item label="期望地点：" label-width="70px">
              <CascaderArea
                :country="clientInfo.expectedCountry"
                :province="clientInfo.expectedProvince"
                :city="clientInfo.expectedCity"
                @searchArae="searchAraeExpected"
              />
            </el-form-item>
          </div>
          <div class="expected">
            <i class="iconfont icon-jr-icon-collar"></i>
            <el-form-item label="期望职位：" label-width="70px">
              <el-input class="large_input" v-model="clientInfo.expectedPosition"></el-input>
            </el-form-item>
          </div>
          <div class="expected">
            <i class="iconfont icon-jr-icon-earth"></i>
            <el-form-item label="期望薪资：" label-width="70px">
              <div class="flexStyle">
                <el-input v-model="clientInfo.salaryExpectation" style="width: 250px">
                  <el-select
                    v-model="clientInfo.isAnnual"
                    slot="prepend"
                    placeholder="请选择"
                    style="width: 100px"
                  >
                    <el-option label="年薪" :value="1"></el-option>
                    <el-option label="月薪" :value="0"></el-option>
                  </el-select>
                </el-input>
                <span class="spanStyle">~</span>
                <el-input v-model="clientInfo.salaryExpectationEnd" class="small_input"></el-input>
              </div>
            </el-form-item>
          </div>
          <div class="expected">
            <i class="iconfont icon-jr-icon-earth"></i>
            <el-form-item label="目前薪资：" label-width="70px">
              <div class="flexStyle">
                <el-input v-model="clientInfo.currentSalaryStart" style="width: 250px">
                  <el-select
                    v-model="clientInfo.isYears"
                    slot="prepend"
                    placeholder="请选择"
                    style="width: 100px"
                  >
                    <el-option label="年薪" :value="1"></el-option>
                    <el-option label="月薪" :value="0"></el-option>
                  </el-select>
                </el-input>
                <el-input
                  v-model="clientInfo.currentSalaryEnd"
                  class="small_input"
                  style="margin-left: 32px"
                  placeholder="十几薪"
                  v-if="!clientInfo.isYears"
                ></el-input>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <div class="flexStyleBottom">
            <title-bar title="教育背景"></title-bar>
            <div class="personEducationalDiv" @click="addPersonEducational">
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div>
          </div>
          <div
            v-for="(item, index) in clientInfo.personEducational"
            :key="index + 20"
            class="personEducational"
          >
            <el-date-picker
              @change="selectStarDate(index, item.startDate)"
              v-model="item.startDate"
              type="month"
              placeholder="选择日期"
              style="width: 150px"
              value-format="yyyy-MM"
            >
            </el-date-picker>
            ~
            <el-date-picker
              v-model="item.endDate"
              type="month"
              placeholder="选择日期"
              style="width: 150px; margin-right: 20px"
              value-format="yyyy-MM"
            >
            </el-date-picker>
            <el-input
              v-model="item.schoolName"
              style="width: 250px; margin-right: 20px"
              placeholder="请输入学校名称"
            ></el-input>
            <el-input
              maxlength="20"
              show-word-limit
              v-model="item.cityName"
              style="width: 200px; margin-right: 20px"
              placeholder="请输入城市"
            ></el-input>
            <!-- <drop-down-box :selectValue.sync="item.education" typeCode="007" class="drop-down-box" /> -->
            <el-select
              v-model="item.education"
              style="width: 150px; margin-right: 20px"
              placeholder="请选择学历"
            >
              <el-option label="中专" value="中专"></el-option>
              <el-option label="大专" value="大专"></el-option>
              <el-option label="本科" value="本科"></el-option>
              <el-option label="硕士" value="硕士"></el-option>
              <el-option label="博士" value="博士"></el-option>
              <el-option label="博士后" value="博士后"></el-option>
            </el-select>
            <el-input v-model="item.major" style="width: 230px" placeholder="请输入专业"></el-input>
            <!-- <div
              class="personEducationalDiv"
              @click="addPersonEducational"
              v-if="clientInfo.personEducational.length == index + 1"
            >
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div> -->
            <div class="personEducationalDiv" @click="deletePersonEducational(index)">
              <i class="el-icon-remove-outline"></i>
              <span>删除</span>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <div class="flexStyleBottom">
            <title-bar title="工作经历及内容"></title-bar>
            <div class="personEducationalDiv" @click="openPersonExperience">
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div>
          </div>
          <div class="personExperience" v-show="personExperienceShow">
            <div class="personExperienceContent">
              <div class="personExperienceFlex">
                <el-form-item label="在职时间：">
                  <el-date-picker
                    v-model="personExperience.inductionTime"
                    type="month"
                    placeholder="选择日期"
                    style="width: 140px"
                    value-format="yyyy-MM"
                  >
                  </el-date-picker>
                  ~
                  <el-date-picker
                    v-model="personExperience.quitTime"
                    type="month"
                    placeholder="至今"
                    value-format="yyyy-MM"
                    style="width: 140px; margin-right: 10px"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="公司名称：">
                  <el-input v-model="personExperience.companyName" style="width: 300px"></el-input>
                </el-form-item>
              </div>
              <div class="personExperienceFlex">
                <el-form-item label="职位：" label-width="100px">
                  <el-input v-model="personExperience.position"></el-input>
                </el-form-item>
                <el-form-item label="地点：" label-width="100px">
                  <el-input v-model="personExperience.location"></el-input>
                </el-form-item>
                <!-- <el-form-item label="所属地点：" label-width="100px">
                  <el-input v-model="personExperience.number"></el-input>
                </el-form-item> -->
              </div>
              <el-form-item label="职位描述：" style="margin-bottom: 0">
                <el-input
                  v-model="personExperience.operatingDuty"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="职位业绩："
                style="margin-bottom: 0; margin-top: 20px; width: 50%"
              >
                <el-input
                  v-model="personExperience.jobPerformance"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="离职原因："
                style="margin-bottom: 0; margin-top: 20px; width: 50%"
              >
                <el-input
                  v-model="personExperience.reasonsLeaving"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                ></el-input>
              </el-form-item>
              <div class="buttonPersonExperience">
                <el-button class="successButtonPersonExperience" @click="addPersonExperience"
                  >完成</el-button
                >
                <el-button @click="cancelPersonExperience">取消</el-button>
              </div>
            </div>
          </div>
          <div
            v-show="!personExperienceShow"
            class="personExperienceMessage"
            v-for="(item, index) in clientInfo.personExperience"
            :key="index + 30"
          >
            <div class="personExperienceContent">
              <div class="flexStyleWork">
                <div class="flexStyle">
                  <div style="color: #999999; width: 160px">
                    {{ item.inductionTime }}~<span v-if="item.quitTime" style="color: #999999">{{
                      item.quitTime
                    }}</span
                    ><span v-else style="color: #999999">至今</span>
                  </div>
                  <div>
                    <div style="font-size: 18px; font-weight: 600">
                      {{ item.companyName
                      }}<span v-if="item.location" style="margin-left: 5px"
                        >[{{ item.location }}]</span
                      >
                    </div>
                    <div style="margin: 10px 10px 10px 0; font-size: 15px">
                      担任职位：{{ item.position }}
                    </div>
                  </div>
                </div>
                <div>
                  <span @click="editPersonExperience(item, index)"
                    ><i class="iconfont icon-jr-icon-modify"></i>编辑</span
                  >
                  <span style="color: #fa5050" @click="deletePersonExperience(item)"
                    ><i class="iconfont icon-jr-icon-delete"></i>删除</span
                  >
                </div>
              </div>

              <div class="flexStyle">
                <div style="width: 160px; font-size: 15px; font-weight: 600">职位描述：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.operatingDuty }}
                </div>
              </div>
              <div class="flexStyle" style="margin-top: 20px">
                <div style="width: 160px; font-size: 15px; font-weight: 600">职位业绩：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.jobPerformance }}
                </div>
              </div>
              <div class="flexStyle" style="margin-top: 20px">
                <div style="width: 160px; font-size: 15px; font-weight: 600">离职原因：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.reasonsLeaving }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <div class="flexStyleBottom">
            <title-bar title="部分项目"></title-bar>
            <div class="personEducationalDiv" @click="openPersonProjectExperience">
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div>
          </div>
          <div class="personExperience" v-show="personProjectExperienceShow">
            <div class="personExperienceContent">
              <div class="personExperienceFlex">
                <el-form-item label="在职时间：">
                  <el-date-picker
                    v-model="personProjectExperience.startTime"
                    type="month"
                    placeholder="选择日期"
                    style="width: 140px"
                    value-format="yyyy-MM"
                  >
                  </el-date-picker>
                  ~
                  <el-date-picker
                    v-model="personProjectExperience.endTime"
                    type="month"
                    placeholder="至今"
                    value-format="yyyy-MM"
                    style="width: 140px; margin-right: 10px"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="项目名称：">
                  <el-input
                    v-model="personProjectExperience.projectName"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="担任角色：" label-width="100px">
                  <el-input v-model="personProjectExperience.projectFunction"></el-input>
                </el-form-item>
              </div>
              <el-form-item label="项目内容：" style="margin-bottom: 0">
                <el-input
                  v-model="personProjectExperience.projectAchievement"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                ></el-input>
              </el-form-item>
              <el-form-item label="项目业绩：" style="margin-bottom: 0; margin-top: 20px">
                <el-input
                  v-model="personProjectExperience.projectPerformance"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                ></el-input>
              </el-form-item>
              <div class="buttonPersonExperience">
                <el-button class="successButtonPersonExperience" @click="addPersonProjectExperience"
                  >完成</el-button
                >
                <el-button @click="cancelPersonProjectExperience">取消</el-button>
              </div>
            </div>
          </div>
          <div
            v-show="!personProjectExperienceShow"
            class="personExperienceMessage"
            v-for="(item, index) in clientInfo.personProjectExperience"
            :key="index + 40"
          >
            <div class="personExperienceContent">
              <div class="flexStyleWork">
                <div class="flexStyle">
                  <div style="color: #999999; width: 160px">
                    {{ item.startTime }}~{{ item.endTime }}
                  </div>
                  <div>
                    <div style="font-size: 18px; font-weight: 600">
                      {{ item.projectName }}
                    </div>
                    <div style="margin: 10px 10px 10px 0; font-size: 15px">
                      担任角色：{{ item.projectFunction }}
                    </div>
                  </div>
                </div>
                <div>
                  <span @click="editPersonProjectExperience(item, index)"
                    ><i class="iconfont icon-jr-icon-modify"></i>编辑</span
                  >
                  <span style="color: #fa5050" @click="deletePersonProjectExperience(item)"
                    ><i class="iconfont icon-jr-icon-delete"></i>删除</span
                  >
                </div>
              </div>

              <div class="flexStyle">
                <div style="width: 160px; font-size: 15px; font-weight: 600">项目描述：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.projectAchievement }}
                </div>
              </div>
              <div class="flexStyle" style="margin-top: 20px">
                <div style="width: 160px; font-size: 15px; font-weight: 600">项目业绩：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.projectPerformance }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="技术能力"></title-bar>
          <div style="margin: 0 0 0 30px">
            <el-tag
              :key="index + 50"
              v-for="(tag, index) in clientInfo.listTechnique"
              closable
              :disable-transitions="false"
              @close="handleCloseTech(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag small_input"
              v-if="inputVisibleTech"
              v-model="inputValueTech"
              ref="saveTagInputTech"
              size="small"
              @keyup.enter.native="handleInputConfirmTech"
              @blur="handleInputConfirmTech"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputTech"
              >添加标签</el-button
            >
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <div class="flexStyleBottom">
            <title-bar title="职业培训"></title-bar>
            <div class="personEducationalDiv" @click="openVocationalTrainings">
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div>
          </div>
          <div class="personExperience" v-show="vocationalTrainingsShow">
            <div class="personExperienceContent">
              <div class="personExperienceFlex">
                <el-form-item label="培训时间：">
                  <el-date-picker
                    v-model="vocationalTrainings.startTime"
                    type="month"
                    placeholder="选择日期"
                    style="width: 140px"
                    value-format="yyyy-MM"
                  >
                  </el-date-picker>
                  ~
                  <el-date-picker
                    v-model="vocationalTrainings.endTime"
                    type="month"
                    placeholder="选择日期"
                    value-format="yyyy-MM"
                    style="width: 140px; margin-right: 10px"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="培训主题：">
                  <el-input
                    v-model="vocationalTrainings.trainingTopics"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item label="培训地点：" label-width="100px">
                <el-input v-model="vocationalTrainings.address" style="width: 400px"></el-input>
              </el-form-item>
              <el-form-item label="培训内容：" style="margin-bottom: 0">
                <el-input
                  v-model="vocationalTrainings.trainingContent"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                ></el-input>
                <div class="buttonPersonExperience">
                  <el-button class="successButtonPersonExperience" @click="addVocationalTrainings"
                    >完成</el-button
                  >
                  <el-button @click="cancelVocationalTrainings">取消</el-button>
                </div>
              </el-form-item>
            </div>
          </div>
          <div
            v-show="!vocationalTrainingsShow"
            class="personExperienceMessage"
            v-for="(item, index) in clientInfo.vocationalTrainings"
            :key="index + 60"
          >
            <div class="personExperienceContent">
              <div class="flexStyleWork">
                <div class="flexStyle">
                  <div style="color: #999999; width: 160px">
                    {{ item.startTime }}~{{ item.endTime }}
                  </div>
                  <div>
                    <div style="font-size: 18px; font-weight: 600">{{ item.trainingTopics }}</div>
                    <div style="margin: 10px 10px 10px 0; font-size: 15px">
                      培训地点：{{ item.address }}
                    </div>
                  </div>
                </div>
                <div>
                  <span @click="editVocationalTrainings(item, index)"
                    ><i class="iconfont icon-jr-icon-modify"></i>编辑</span
                  >
                  <span style="color: #fa5050" @click="deleteVocationalTrainings(item)"
                    ><i class="iconfont icon-jr-icon-delete"></i>删除</span
                  >
                </div>
              </div>

              <div class="flexStyle">
                <div style="width: 160px; font-size: 15px; font-weight: 600">培训内容：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.trainingContent }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <div class="flexStyleBottom">
            <title-bar title="专业认证"></title-bar>
            <div class="personEducationalDiv" @click="addCertifications">
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div>
          </div>
          <div
            v-for="(item, index) in clientInfo.certifications"
            :key="index + 70"
            class="personEducational"
          >
            <el-date-picker
              v-model="item.startTime"
              type="month"
              placeholder="选择日期"
              style="width: 150px"
              value-format="yyyy-MM"
            >
            </el-date-picker>
            ~
            <el-date-picker
              v-model="item.endTime"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择日期"
              style="width: 150px; margin-right: 20px"
            >
            </el-date-picker>
            <el-input
              v-model="item.address"
              style="width: 300px; margin-right: 20px"
              placeholder="请输入地点"
            ></el-input>
            <el-input
              v-model="item.certificateName"
              style="width: 270px"
              placeholder="请输入专业证书"
            ></el-input>
            <!-- <div
              class="personEducationalDiv"
              @click="addCertifications"
              v-if="clientInfo.certifications.length == index + 1"
            >
              <i class="el-icon-circle-plus-outline"></i>
              <span>添加</span>
            </div> -->
            <div class="personEducationalDiv" @click="deleteCertifications(index)">
              <i class="el-icon-remove-outline"></i>
              <span>删除</span>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="业界荣誉"></title-bar>
          <div style="margin: 0 0 0 30px">
            <el-tag
              :key="index + 80"
              v-for="(tag, index) in clientInfo.listHonor"
              closable
              :disable-transitions="false"
              @close="handleCloseHonor(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag small_input"
              v-if="inputVisibleHonor"
              v-model="inputValueHonor"
              ref="saveTagInputHonor"
              size="small"
              @keyup.enter.native="handleInputConfirmHonor"
              @blur="handleInputConfirmHonor"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputHonor"
              >添加标签</el-button
            >
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="自我评价"></title-bar>
          <div style="margin: 0px 20px 20px 30px">
            <el-input
              v-model="clientInfo.selfAssessment"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
            ></el-input>
          </div>
        </div>
      </el-form>
    </div>
    <div class="buttonStyle">
      <el-button class="saveButton" @click="save">保存</el-button>
      <el-button class="cancelButton" @click="cancel"> 返回上级</el-button>
    </div>
    <!-- <div class="bottom"></div> -->
  </div>
</template>

<script>
import { getBothYearList } from '@/utils/function.js'
import CascaderArea from '@/components/CascaderArea.vue'
import UploadImage from '@/components/UploadImage.vue'
import { insertPerson, updatePerson, getParticularsPersonByid } from '@/api/talent.js'
import DropDownBox from '@/components/DropDownBox.vue'
import TitleBar from '@/components/TitleBar.vue'
import DicCascader from '@/components/DicCascader.vue'
// import { saveIntermediateListTwo } from '@/api/projectCenter.js'
import { insertPersonNew, saveIntermediateListTwo } from '@/api/projectCenter.js'

export default {
  components: {
    UploadImage,
    CascaderArea,
    DropDownBox,
    TitleBar,
    DicCascader
  },
  data() {
    return {
      yearList: [], // 年份列表
      options: ['不限', '1年以内', '1~3年', '3~5年', '5~10年', '10年以上'],
      // 个人荣誉标签
      inputVisible: false,
      inputValue: '',
      // 技术能力
      inputVisibleTech: false,
      inputValueTech: '',
      // 业界荣誉
      inputVisibleHonor: false,
      inputValueHonor: '',
      // 工作经历
      personExperienceIndex: null,
      experienceEditIndex: false,
      personExperience: {
        //工作经历
        companyName: '', //公司名称
        position: '', //公司职务
        salaryExpectation: '', //薪资范围
        salaryExpectationEnd: '', //薪资范围
        inductionTime: '', //加入时间
        quitTime: '', //离职时间时间
        operatingDuty: '', //职位描述
        location: '', //下属人数
        jobPerformance: '',
        reasonsLeaving: '' // 离职原因
      },
      // personDetailsWorkExperiences: [],
      // 工作经历判断条件
      personExperienceShow: false,

      // 项目经历
      personProjectExperience: {
        //项目经历
        startTime: '', //开始时间
        endTime: '', //结束时间
        projectName: '', //项目名称
        projectAchievement: '', //项目内容
        projectFunction: '', //担任角色
        projectPerformance: ''
      },
      // 项目经理判断条件
      personProjectExperienceShow: false,
      personProjectExperienceIndex: null,
      projectExperienceIndex: false,

      // 职业培训
      vocationalTrainings: {
        //职业培训
        startTime: '', //开始时间
        endTime: '', //结束时间
        trainingTopics: '', //培训主题
        trainingContent: '', //培训内容
        address: '' //培训地点
      },
      // 职业培训判断条件
      vocationalTrainingsShow: false,
      vocationalTrainingsIndex: null,
      vocationalTrainingsIndexBoolean: false,

      // 语言能力
      listLanguageAbility: [
        {
          LanguageAbility: '中文', //语言能力
          LanguageLevel: '母语' //语言等级
        }
      ],

      // 基本信息（点击提交数据）
      clientInfo: {
        isYears: 0,
        birthYear: '', // 出生年份
        listLanguageAbility: [],
        timeChoose: '', //入职时间选择
        entryTime: '', //入职时间
        jobChannels: '', //求职渠道
        weddingOrNot: 0, //婚姻状态
        listEducationBackground: [], //教育背景
        isAnnual: 0,
        personDetailsWorkExperiences: [],
        headPortrait: '', //头像
        name: '', //姓名
        sex: '', //性别
        age: '', //年龄
        phone: '', //联系电话
        listCurrentIndustry: [], //所属行业
        workingYears: '', //工作经验
        personType: '', //职位类型
        listPersonalGlory: [], //个人荣誉标签
        other: '', //其他
        state: '', //当前状态
        personCountry: '中国', //所在国家
        personProvince: '', //所在省份
        personCity: '', //所在城市
        mail: '', //邮箱
        weChat: '', //微信
        personExperience: [],
        expectedCountry: '', //期望国家
        expectedProvince: '', //期望省份
        expectedCity: '', //期望城市
        expectedPosition: '', //期望职位
        salaryExpectation: '', //期望薪资
        salaryExpectationEnd: '', //期望薪资结束
        //教育经历
        personEducational: [
          {
            startDate: '', //开始时间
            endDate: '', //结束时间
            schoolName: '', //学校名称
            education: '本科', //学历
            major: '', //就读专业
            cityName: '' // 所在学校城市
          }
        ],
        // personDetailsWorkExperiences: [],
        personProjectExperience: [],
        listTechnique: [], //我的技能
        vocationalTrainings: [],
        //专业认证
        certifications: [
          // {
          //   startTime: '', //开始时间
          //   endTime: '', //结束时间
          //   address: '', //地点
          //   certificateName: '' //专业证书
          // }
        ],
        listHonor: [], //业界荣誉
        selfAssessment: '' //自我评价
      },
      salary: [],
      rules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'onChange' }],
        // sex: [{ required: true, message: '请填写性别', trigger: 'onChange' }],
        // age: [{ required: true, message: '请填写年龄', trigger: 'onChange' }],
        phone: [{ required: true, message: '请填写联系电话', trigger: 'onChange' }]
        // listCurrentIndustry: [{ required: true, message: '请填写所属行业', trigger: 'onChange' }]
      }
    }
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    },
    clientType() {
      return this.$route.query.clientType
    },
    clientId() {
      return this.$route.query.id
    },
    tabName() {
      return this.$route.query.tabName
    },
    projectId() {
      return Number(this.$route.query.id)
    },
    projectPositionType() {
      return this.$route.query.positionType
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
    // newAge: {
    //   get() {
    //     return this.clientInfo.birthYear? new Date().getFullYear() - this.clientInfo.birthYear : this.clientInfo.age
    //   },
    //   set(newVal){
    //     this.clientInfo.age = newVal
    //   }
    // },
    // newBirthYear:{
    //   get() {
    //     return this.clientInfo.age? new Date().getFullYear() - this.clientInfo.age : this.clientInfo.birthYear
    //   },
    //   set(newVal){
    //     // console.log(newVal);
    //     this.clientInfo.birthYear = newVal
    //   }
    // }
  },
  // watch: {
  //   'clientInfo.birthYear': {
  //     handler(newValue, oldValue){
  //       // console.log(newValue);
  //       if (newValue){
  //         this.clientInfo.age = new Date().getFullYear() - newValue
  //       }else{
  //         this.clientInfo.birthYear = new Date().getFullYear() - this.clientInfo.age
  //       }
  //     },
  //     immediate: true
  //   },
  //   'clientInfo.age': {
  //     handler(newValue){
  //       if(newValue) {
  //         console.log(11111111111111111111);
  //         this.clientInfo.birthYear = new Date().getFullYear() - newValue
  //       }else{
  //         this.clientInfo.age = new Date().getFullYear() - this.clientInfo.birthYear
  //       }

  //     },
  //     immediate: true
  //   }
  // },
  created() {
    this.yearList = getBothYearList(50, 0)
    this.$store.commit('changeQueryInfo', this.searchInfo)
    this.routerTo()
    if (this.clientType) {
      this.getpositionListByid()
    }
  },
  methods: {
    // 选择生日
    birthYearChange(val) {
      val ? (this.clientInfo.age = new Date().getFullYear() - val) : this.clientInfo.age
      this.clientInfo.birthYear = val
    },
    // 修改年龄
    ageInput(val) {
      val ? (this.clientInfo.birthYear = new Date().getFullYear() - val) : this.clientInfo.birthYear
      this.clientInfo.age = val
    },
    // 选择教育经历开始时间
    selectStarDate(index, val) {
      // 教育经历，默认有一段，且学历默认本科，填完入学时间，毕业时间自动+4年，6月
      // 例如：填写入学时间2017-09后 -毕业时间系统自动填充为 2021-06月
      if (val) {
        const dateArr = val.split('-')
        this.clientInfo.personEducational[index].endDate = dateArr[0] * 1 + 4 + '-6'
      } else {
        this.clientInfo.personEducational[index].startDate = ''
        this.clientInfo.personEducational[index].endDate = ''
      }
    },
    routerTo() {
      document.body.scrollTop = 0
    },
    // 单个查询
    async getpositionListByid() {
      const { data: res } = await getParticularsPersonByid({ PreCode: this.clientId })
      if (res.resultCode == 200) {
        this.clientInfo = res.data
        if (!this.clientInfo.personEducational || !this.clientInfo.personEducational.length) {
          // 教育经历，默认有一段，且学历默认本科，填完入学时间，毕业时间自动+4年，6月
          this.clientInfo.personEducational = [
            {
              startDate: '', //开始时间
              endDate: '', //结束时间
              schoolName: '', //学校名称
              education: '本科', //学历
              major: '' //就读专业
            }
          ]
        }
        if (this.clientInfo.salaryRange) {
          this.salary = this.clientInfo.salaryRange.split('~')
        }
        if (!this.clientInfo.listHonor) {
          this.clientInfo.listHonor = []
        }
        if (!this.clientInfo.listPersonalGlory) {
          this.clientInfo.listPersonalGlory = []
        }
        if (!this.clientInfo.listTechnique) {
          this.clientInfo.listTechnique = []
        }
        if (!this.clientInfo.listCurrentIndustry) {
          this.clientInfo.listCurrentIndustry = []
        }
        if (this.clientInfo.listLanguageAbility && this.clientInfo.listLanguageAbility.length > 0) {
          // this.clientInfo.languageAbility = this.clientInfo.languageAbility.split(',')
          this.listLanguageAbility = this.clientInfo.listLanguageAbility.map((item) => {
            const ability = item.split('/')
            return {
              LanguageAbility: ability[0],
              LanguageLevel: ability[1]
            }
          })
          console.log(this.listLanguageAbility)
        }
      }
      if (!this.clientInfo.educationBackground) {
        this.clientInfo.listEducationBackground = []
      } else {
        this.clientInfo.listEducationBackground = this.clientInfo.educationBackground.split(',')
        console.log(111)
      }
      console.log(this.clientInfo)
    },
    //   添加联系人
    addprojectLeaderListAdd() {
      this.clientInfo.projectLeaderListAdd.push({
        contactInformation: '', //微信号
        projectLeader: '', //联系人姓名
        targetEnterprise: ''
      })
    },
    // 国家地区
    searchArae(val) {
      this.clientInfo.personCountry = val.country

      this.clientInfo.personProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.clientInfo.personCity = val.city
      }
    },
    // 期望国家地区
    searchAraeExpected(val) {
      this.clientInfo.expectedCountry = val.country

      this.clientInfo.expectedProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.clientInfo.expectedCity = val.city
      }
    },
    //   删除联系人
    removeprojectLeaderListAdd(index) {
      this.clientInfo.projectLeaderListAdd.splice(index, 1)
    },

    // 保存
    async save() {
      this.$refs.clientFormRules.validate(async (valid) => {
        if (valid) {
          if (this.salary.length > 0) {
            this.clientInfo.salaryRange = this.salary.join('~')
          }
          // if (this.clientInfo.age) {
          //   this.clientInfo.age = Number(this.clientInfo.age)
          // }
          let res
          if (this.clientInfo.listLanguageAbility && this.listLanguageAbility.length > 0) {
            this.clientInfo.listLanguageAbility = this.listLanguageAbility.map((item) => {
              return item.LanguageAbility + '/' + item.LanguageLevel
            })
          } else {
            this.clientInfo.listLanguageAbility = []
          }
          // if (this.clientInfo.languageAbility.length > 0) {
          //   this.clientInfo.languageAbility = this.clientInfo.languageAbility.split(',')
          // } else {
          //   this.clientInfo.languageAbility = ''
          // }
          if (this.clientType) {
            if (this.clientInfo.personExperience.length > 0) {
              this.clientInfo.personExperience.map((item) => {
                return (item.personnelCode = this.clientId)
              })
            }
            if (this.clientInfo.personExperience.length > 0) {
              this.clientInfo.personExperience.map((item) => {
                if (item.quitTime == '') return (item.quitTime = '1999')
              })
            }
            if (this.clientInfo.personDetailsWorkExperiences.length > 0) {
              this.clientInfo.personDetailsWorkExperiences.map((item) => {
                return (item.personnelCode = this.clientId)
              })
            }
            if (this.clientInfo.personProjectExperience.length > 0) {
              this.clientInfo.personProjectExperience.map((item) => {
                return (item.personCode = this.clientId)
              })
            }
            if (this.clientInfo.vocationalTrainings.length > 0) {
              this.clientInfo.vocationalTrainings.map((item) => {
                return (item.personnelCode = this.clientId)
              })
            }
            if (this.clientInfo.personEducational.length > 0) {
              this.clientInfo.personEducational.map((item) => {
                return (item.personCode = this.clientId)
              })
            }
            if (this.clientInfo.certifications.length > 0) {
              this.clientInfo.certifications.map((item) => {
                return (item.personnelCode = this.clientId)
              })
            }
            res = await updatePerson(this.clientInfo)
          } else {
            if (this.clientInfo.personExperience.length > 0) {
              this.clientInfo.personExperience.map((item) => {
                if (item.quitTime == '') return (item.quitTime = '1999')
              })
            }
            res = await insertPersonNew(this.clientInfo)
            console.log(this.clientInfo)
          }
          if (res.data.resultCode === 200) {
            if (this.clientType) {
              this.$message.success('修改成功')
            } else {
              this.$message.success('新增成功')
            }
            // 候选列表进来的 多调一个接口
            if (this.$route.query.uploadState) {
              let id = this.$route.query.projectAddId
              let personCode = []
              personCode.push(res.data.data)
              const { data: resS } = await saveIntermediateListTwo({
                personCode: personCode,
                projectId: id
              })
              console.log(resS, 'resS')
            }

            this.cancel()
          }
        }
      })
    },
    // 返回
    cancel() {
      if (this.tabName) {
        this.$router.push({
          name: 'Candidate',
          query: {
            tabName: this.tabName,
            id: this.projectId,
            positionType: this.projectPositionType,
            searchInfo: JSON.stringify(this.searchInfo)
          }
        })
      } else {
        this.$router.back()
      }
    },
    // 删除图片
    deleteImg() {
      this.clientInfo.headPortrait = ''
      this.clientInfo.headPortraits = ''
    },
    // 个人荣誉标签
    handleClose(tag) {
      this.clientInfo.listPersonalGlory.splice(this.clientInfo.listPersonalGlory.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.clientInfo.listPersonalGlory.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 我的技能
    handleCloseTech(tag) {
      this.clientInfo.listTechnique.splice(this.clientInfo.listTechnique.indexOf(tag), 1)
    },
    showInputTech() {
      this.inputVisibleTech = true
      this.$nextTick(() => {
        this.$refs.saveTagInputTech.$refs.input.focus()
      })
    },
    handleInputConfirmTech() {
      let inputValue = this.inputValueTech
      if (inputValue) {
        this.clientInfo.listTechnique.push(inputValue)
      }
      this.inputVisibleTech = false
      this.inputValueTech = ''
    },
    // 业界荣誉
    handleCloseHonor(tag) {
      this.clientInfo.listHonor.splice(this.clientInfo.listHonor.indexOf(tag), 1)
    },
    showInputHonor() {
      this.inputVisibleHonor = true
      this.$nextTick(() => {
        this.$refs.saveTagInputHonor.$refs.input.focus()
      })
    },
    handleInputConfirmHonor() {
      let inputValue = this.inputValueHonor
      if (inputValue) {
        this.clientInfo.listHonor.push(inputValue)
      }
      this.inputVisibleHonor = false
      this.inputValueHonor = ''
    },
    // 添加教育经历
    addPersonEducational() {
      this.clientInfo.personEducational.push({
        //教育经历
        startDate: '', //开始时间
        endDate: '', //结束时间
        schoolName: '', //学校名称
        education: '', //学历
        major: '' //就读专业
      })
    },
    // 删除教育经历
    deletePersonEducational(index) {
      this.clientInfo.personEducational.splice(index, 1)
    },
    // 添加工作经历
    addpersonDetailsWorkExperiences() {
      this.clientInfo.personDetailsWorkExperiences.push({
        //工作经历
        companyName: '', //公司名称
        position: '', //公司职务
        salaryExpectation: '', //薪资范围
        salaryExpectationEnd: '', //薪资范围
        inductionTime: '', //加入时间
        quitTime: '', //离职时间时间
        reportingObject: '', //汇报对象
        department: '' //所属部门
      })
    },
    // 删除工作经历
    deletepersonDetailsWorkExperiences(index) {
      this.clientInfo.personDetailsWorkExperiences.splice(index, 1)
    },
    // 添加证书
    addCertifications() {
      this.clientInfo.certifications.push({
        startTime: '', //开始时间
        endTime: '', //结束时间
        address: '', //地点
        certificateName: '' //专业证书
      })
    },
    // 删除证书
    deleteCertifications(index) {
      this.clientInfo.certifications.splice(index, 1)
    },
    //打开工作经历
    openPersonExperience() {
      this.personExperienceShow = true
    },
    //添加工作经历
    addPersonExperience() {
      console.log(this.experienceEditIndex)
      if (this.experienceEditIndex) {
        this.clientInfo.personExperience[this.personExperienceIndex] = this.personExperience
        ;(this.experienceEditIndex = false),
          (this.personExperience = {
            companyName: '', //公司名称
            position: '', //公司职务
            salaryExpectation: '', //薪资范围
            salaryExpectationEnd: '', //薪资范围
            inductionTime: '', //加入时间
            quitTime: '', //离职时间时间
            operatingDuty: '' //职位描述
          })
        this.personExperienceShow = false
      } else {
        if (!this.personExperience.companyName) {
          this.$message.error('请填写公司名称')
        } else if (!this.personExperience.inductionTime && !this.personExperience.quitTime) {
          this.$message.error('请填写时间')
        } else {
          this.clientInfo.personExperience.push(this.personExperience)
          this.personExperience = {
            companyName: '', //公司名称
            position: '', //公司职务
            salaryExpectation: '', //薪资范围
            salaryExpectationEnd: '', //薪资范围
            inductionTime: '', //加入时间
            quitTime: '', //离职时间时间
            operatingDuty: '' //职位描述
          }
          this.personExperienceShow = false
        }
      }
    },
    // 关闭工作经历
    cancelPersonExperience() {
      this.personExperienceShow = false
      this.personExperience = {
        companyName: '', //公司名称
        position: '', //公司职务
        salaryExpectation: '', //薪资范围
        salaryExpectationEnd: '', //薪资范围
        inductionTime: '', //加入时间
        quitTime: '', //离职时间时间
        operatingDuty: '' //职位描述
      }
    },
    // 编辑工作经历
    editPersonExperience(item, index) {
      this.personExperience = item
      this.personExperienceIndex = index
      this.personExperienceShow = true
      this.experienceEditIndex = true
    },
    // 删除工作经历
    deletePersonExperience(item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.clientInfo.personExperience.splice(item, 1)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //打开项目经历
    openPersonProjectExperience() {
      this.personProjectExperienceShow = true
    },
    //添加项目经历
    addPersonProjectExperience() {
      if (this.projectExperienceIndex) {
        this.clientInfo.personProjectExperience[this.personProjectExperienceIndex] =
          this.personProjectExperience
        ;(this.projectExperienceIndex = false),
          (this.personProjectExperience = {
            startTime: '', //开始时间
            endTime: '', //结束时间
            projectName: '', //项目名称
            projectAchievement: '', //项目内容
            projectFunction: '' //担任角色
          })
        this.personProjectExperienceShow = false
      } else {
        if (!this.personProjectExperience.projectName) {
          this.$message.error('请填写项目名称')
        } else if (
          !this.personProjectExperience.startTime &&
          !this.personProjectExperience.endTime
        ) {
          this.$message.error('请填写时间')
        } else {
          this.clientInfo.personProjectExperience.push(this.personProjectExperience)
          this.personProjectExperience = {
            startTime: '', //开始时间
            endTime: '', //结束时间
            projectName: '', //项目名称
            projectAchievement: '', //项目内容
            projectFunction: '' //担任角色
          }
          this.personProjectExperienceShow = false
        }
      }
    },
    // 关闭项目经历
    cancelPersonProjectExperience() {
      this.personProjectExperienceShow = false
      this.personProjectExperience = {
        startTime: '', //开始时间
        endTime: '', //结束时间
        projectName: '', //项目名称
        projectAchievement: '', //项目内容
        projectFunction: '' //担任角色
      }
    },
    // 编辑项目经历
    editPersonProjectExperience(item, index) {
      this.personProjectExperience = item
      this.personProjectExperienceIndex = index
      this.projectExperienceIndex = true
      this.personProjectExperienceShow = true
    },
    // 删除项目经历
    deletePersonProjectExperience(item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.clientInfo.personProjectExperience.splice(item, 1)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //打开职业培训
    openVocationalTrainings() {
      this.vocationalTrainingsShow = true
    },
    //添加职业培训
    addVocationalTrainings() {
      if (this.vocationalTrainingsIndexBoolean) {
        this.clientInfo.vocationalTrainings[this.vocationalTrainingsIndex] =
          this.vocationalTrainings
        ;(this.vocationalTrainingsIndexBoolean = false),
          (this.vocationalTrainings = {
            startTime: '', //开始时间
            endTime: '', //结束时间
            trainingTopics: '', //培训主题
            trainingContent: '', //培训内容
            address: '' //培训地点
          })
        this.vocationalTrainingsShow = false
      } else {
        if (!this.vocationalTrainings.trainingTopics) {
          this.$message.error('请填写培训主题')
        } else if (!this.vocationalTrainings.startTime && !this.vocationalTrainings.endTime) {
          this.$message.error('请填写时间')
        } else {
          this.clientInfo.vocationalTrainings.push(this.vocationalTrainings)
          this.vocationalTrainings = {
            startTime: '', //开始时间
            endTime: '', //结束时间
            trainingTopics: '', //培训主题
            trainingContent: '', //培训内容
            address: '' //培训地点
          }
        }
      }
      this.vocationalTrainingsShow = false
    },
    // 关闭职业培训
    cancelVocationalTrainings() {
      this.vocationalTrainingsShow = false
      this.vocationalTrainings = {
        startTime: '', //开始时间
        endTime: '', //结束时间
        trainingTopics: '', //培训主题
        trainingContent: '', //培训内容
        address: '' //培训地点
      }
    },
    // 编辑职业培训
    editVocationalTrainings(item, index) {
      this.vocationalTrainings = item
      this.vocationalTrainingsIndex = index
      this.vocationalTrainingsIndexBoolean = true
      this.vocationalTrainingsShow = true
    },
    // 删除职业培训
    deleteVocationalTrainings(item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.clientInfo.vocationalTrainings.splice(item, 1)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 添加语言能力
    addpersonEducationalDivRadio() {
      this.listLanguageAbility.push({
        //教育经历
        LanguageAbility: '', //开始时间
        LanguageLevel: '' //结束时间
      })
      this.clientInfo.listLanguageAbility = this.listLanguageAbility
    },
    removepersonEducationalDivRadio(index) {
      this.listLanguageAbility.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="less">
.mainContent {
  background-color: #fff;
  padding: 20px;
  // width: 100%;
  // height: 100%;
  overflow: auto;

  .expected {
    display: flex;
    align-items: center;
    margin-left: 30px;
    margin-bottom: 20px;

    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}

.flexStyle {
  display: flex;
}

.flexStyleCloum {
  display: flex;
  flex-direction: column;
}

.inputStyle {
  /deep/ .el-input {
    margin: 0 5px 5px 0;
  }

  .iconStyle {
    display: inline-block;
    height: 100%;
    font-size: 28px;
    vertical-align: middle;
    cursor: pointer;
    color: #17757a;
  }
}

.buttonStyle {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 72px;
  left: 0;
  bottom: -10px;
  background: #fff;
  width: 100%;
  box-shadow: 0px 0px 4px 0px #00000040;
}

/deep/ .saveButton {
  background-color: #17757a !important;
  color: #fff !important;
  padding: 10px 30px;
  border: 1px solid #17757a;
}

/deep/ .cancelButton {
  border-color: #17757a !important;
  color: #17757a;
  padding: 10px 30px;
}

/deep/ .el-button:focus,
.el-button:hover {
  background-color: #fff;
}

.bottom {
  height: 20px;
}

.spanStyle {
  display: inline-block;
  padding: 0 10px;
  color: #17757a;
}

.drop-down-box {
  /deep/ .el-input__inner {
    width: 100%;
  }

  /deep/ .el-select {
    width: 100%;
  }
}

.formStyle {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .el-form-item__label {
    display: block;
    width: 100% !important;
    text-align: left;
    color: #17757a;
    font-size: 15px;
    font-weight: 600;
  }
}

.imgStyle {
  text-align: center;

  /deep/ .el-button {
    padding: 5px 10px;
    border-color: #17757a;
    color: #17757a;
  }
}

i {
  color: #17757a;
  font-size: 18px;
  margin-right: 5px !important;
  display: inline-block;
}

/deep/ .el-tag .el-tag__close {
  color: #17757a;
}

/deep/ .el-tag .el-tag__close:hover {
  color: #fff;
}

/deep/ .el-button:focus,
.el-button:hover {
  border-color: #17757a;
  color: #17757a;
}

/deep/ .el-form-item__label {
  padding: 0;
}

.personEducational {
  padding: 0 0 20px 30px;
}

.personEducationalDiv {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
}

i {
  font-size: 20px;
  margin-right: 0;
  vertical-align: bottom;
}

span {
  color: #17757a;
  font-size: 16px;
  display: inline-block;
}

.flexStyleBottom {
  display: flex;
  justify-content: space-between;

  .personEducationalDiv {
    margin-right: 10%;
  }

  span {
    display: inline-block;
    vertical-align: bottom;
    line-height: 23px;
  }
}

// 工作经历
.personExperience {
  height: 100%;
  width: 100%;
  transition: all 0.2s ease;
  box-sizing: border-box;
  padding: 0 20px 20px 20px;

  .personExperienceContent {
    background-color: #fafdfb;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
  }

  .personExperienceFlex {
    display: flex;
  }

  .buttonPersonExperience {
    text-align: right;
    padding: 20px 20px 0 20px;

    .successButtonPersonExperience {
      background-color: #17757a;
      color: #fff;
      border: 1px solid #17757a;
    }
  }
}

// 工作经历详情
.personExperienceMessage {
  // background-color: yellow;/
  width: 90%;
  padding: 0 20px 20px 30px;

  .personExperienceContent {
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    padding: 20px;
  }

  .flexStyleWork {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  span {
    display: inline-block;
    margin-right: 20px;
    cursor: pointer;

    .icon-jr-icon-delete {
      color: #fa5050;
    }
  }
}

.clientContent {
  width: 100%;
  height: auto !important;
  position: relative;
  padding-bottom: 72px;

  .clientForm {
    width: 100%;
    height: calc(100vh - 124px - 72px);
    overflow: auto;
  }
}

/deep/ .el-tag {
  font-size: 12px !important;
}

.radioButtonStyle {
  /deep/ .el-radio-button__inner {
    border: 1px solid #17757a !important;
    padding: 10px 10px;
  }

  /deep/ .el-radio-button__inner:hover {
    color: #17757a;
    background-color: #fff;
  }

  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #17757a;
    color: #fff;
    border: 1px solid #17757a !important;
    box-shadow: none;
  }

  /deep/ .el-radio-button.is-checked .el-radio-button__inner {
    box-shadow: none;
  }
}

.personEducationalDivRadio {
  margin-left: 5px;
  color: #17757a;
  cursor: pointer;
  display: flex;
  align-items: center;

  .el-icon-circle-plus-outline {
    vertical-align: middle;
    font-size: 21px;
    margin-right: 0 !important;
  }

  .el-icon-remove-outline {
    vertical-align: middle;
    font-size: 21px;
    margin-right: 0 !important;
  }
}

::v-deep .el-form-item .el-cascader {
  width: 100%;
}

/* 媒体查询：自适应 */
// // 1680x1050 (1680x889)
// @media (max-width: 1682px) and (max-height: 890px) {
//   .form_content {
//     height: calc(100vh - 128px - 57px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 14px !important;
//   }
// }

// // 1600x900 (1600x739)
// @media (max-width: 1602px) and (max-height: 740px) {
//   .form_content {
//     height: calc(100vh - 128px - 57px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 164px !important;
//   }
// }

// // 1366x768 (1366x607)
// @media (max-width: 1368px) and (max-height: 608px) {
//   .form_content {
//     height: calc(100vh - 128px - 57px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 296px !important;
//   }
// }

// // 1280x1024 (1280x863)
// @media (max-width: 1282px) and (max-height: 864px) {
//   .form_content {
//     height: calc(100vh - 128px - 57px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 40px !important;
//   }
// }

// // 1280x960 (1280x799)
// @media (max-width: 1282px) and (max-height: 800px) {
//   .form_content {
//     height: calc(100vh - 128px - 57px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 106px !important;
//   }
// }

// // 1280x800 (1280x639)
// @media (max-width: 1282px) and (max-height: 640px) {
//   .form_content {
//     height: calc(100vh - 128px - 54px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 262px !important;
//   }
// }

// // 1280x768 (1280x607)
// @media (max-width: 1282px) and (max-height: 608px) {
//   .form_content {
//     height: calc(100vh - 128px - 54px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 296px !important;
//   }
// }

// // 1280x720 (1280x599)
// @media (max-width: 1282px) and (max-height: 600px) {
//   .form_content {
//     height: calc(100vh - 128px - 54px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 342px !important;
//   }
// }

// // 1280x600 (1280x439)
// @media (max-width: 1282px) and (max-height: 440px) {
//   .form_content {
//     height: calc(100vh - 128px - 54px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 464px !important;
//   }
// }

// // 1152x864 (1152x703)
// @media (max-width: 1153px) and (max-height: 704px) {
//   .form_content {
//     height: calc(100vh - 128px - 54px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 198px !important;
//   }
// }

// // 1024x768 (1024x607)
// @media (max-width: 1025px) and (max-height: 608px) {
//   .form_content {
//     height: calc(100vh - 128px - 54px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 294px !important;
//   }
// }

// // 800x600 (800x439)
// @media (max-width: 801px) and (max-height: 440px) {
//   .form_content {
//     height: calc(100vh - 128px - 54px) !important;
//     padding-bottom: 57px !important;
//     overflow: auto;
//   }
//   .business_details_foot_btn {
//     bottom: 462px !important;
//   }
// }
</style>
